export const libsAssetManifestSriHashes = {
  "https://vas2t.wpscdn.cn/vas2t-prod/informat-frontend/1.0.7/libs/remote-entry.1.8.250313160700.js": "sha384-oZ6GPM/wMyz7rGSl+tcW+YCaBRl/vkO1Qwd8IEONc7bOHKngECP42ZSSyxhpAbT2"
};